import React from 'react'
import "../../styles/pages-styles/landing-layout-pages-styles/Login.css";


const Login = () => {
  return (
    <div>
      <div className="login-container">
        <div className="login-card">
          {/* Logo and Header */}
          <div className="header">
            <h1 className="logo">
              <a id='home' href="/">
              Pass<span className="logo-highlight">Medicence</span>
              </a>
            </h1>
            <p className="subtitle">Welcome back! Log in to your account</p>
          </div>

          {/* Form */}
          <form className="login-form">
            {/* Email or Student ID */}
            <div className="form-group">
              <label htmlFor="email">Email or Student ID</label>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="Enter your email or student ID"
              />
            </div>

            {/* Password */}
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Enter your password"
              />
            </div>

            {/* Remember Me and Forgot Password */}
            <div className="form-options">
              <div className="remember-me">
                <input id="rememberMe" name="rememberMe" type="checkbox" />
                <label htmlFor="rememberMe">Remember me</label>
              </div>
              <a href="#" className="forgot-link">
                Forgot password?
              </a>
            </div>

            {/* Submit Button */}
            <button type="submit" className="login-button">
              Log In
            </button>

            {/* Signup Link */}
            <div className="signup-link">
              <p>
                Don't have an account?{" "}
                <a href="/signup" className="link">
                  Sign up
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login